export interface ResponseFormat<T> {
  data: T;
  status: number;
  message: string;
  errors?: Array<string>;
}

export interface PaginatedResponse<T> {
  content: T;
  totalElements: number;
  totalPages: number;
  page: number;
  size: number;
}

export type Cookies = {
  [key: string]: Record<string, T>; // Allow any key - See https://stackoverflow.com/a/47572701/2391795
};

export const EventTypes = {
  ADD_TASK: 'ADD_TASK',
  REMOVE_TASK: 'REMOVE_TASK',
  ADD_STAFF: 'ADD_STAFF',
  UPDATE_STAFF: 'UPDATE_STAFF',
  REMOVE_STAFF: 'REMOVE_STAFF',
  ADD_SUPERVISION: 'ADD_SUPERVISION',
  UPDATE_SUPERVISION: 'UPDATE_SUPERVISION',
  REMOVE_SUPERVISION: 'REMOVE_SUPERVISION',
  ADD_QUEUE: 'ADD_QUEUE',
  REMOVE_QUEUE: 'REMOVE_QUEUE',
  UPDATE_TASK: 'UPDATE_TASK',
  USER_JOINED: 'USER_JOINED',
  USER_LEFT: 'USER_LEFT',
  NEW_MESSAGE: 'NEW_MESSAGE',
  IS_TYPING: 'IS_TYPING',
  TERMINATE_USER_SESSION: 'TERMINATE_USER_SESSION',
  SWOOPIN_SUPERVISOR: 'SWOOPIN_SUPERVISOR',
  ADD_PARTICIPANT_TASK: 'ADD_PARTICIPANT_TASK',
  REMOVE_PARTICIPANT_TASK: 'REMOVE_PARTICIPANT_TASK',
  UPDATE_PARTICIPANT_TASK: 'UPDATE_PARTICIPANT_TASK',
  MESSAGE: 'MESSAGE',
  NOTIFICATION: 'NOTIFICATION',
  CLEAR: 'CLEAR',
  END_SESSION: 'END_SESSION',
  MODERATOR_JOIN: 'MODERATOR_JOIN',
  MODERATOR_LEAVE: 'MODERATOR_LEAVE',
  VISITOR_JOIN: 'VISITOR_JOIN',
  VISITOR_LEAVE: 'VISITOR_LEAVE',
  ONE_ON_ONE_INVITE: 'ONE_ON_ONE_INVITE',
  VISITOR_CONNECTED: 'VISITOR_CONNECTED',
  VISITOR_DISCONNECTED: 'VISITOR_DISCONNECTED',
  USER_LOGOUT: 'USER_LOGOUT'
};
export interface EventFormat<T> {
  data: T;
  event:
    | 'ADD_TASK'
    | 'USER_JOINED'
    | 'USER_LEFT'
    | 'NEW_MESSAGE'
    | 'REMOVE_TASK'
    | 'UPDATE_TASK'
    | 'ADD_STAFFER'
    | 'UPDATE_STAFFER'
    | 'REMOVE_STAFFER'
    | 'ADD_SUPERVISOR'
    | 'UPDATE_SUPERVISOR'
    | 'REMOVE_SUPERVISOR'
    | 'ADD_QUEUE'
    | 'SWOOPIN_SUPERVISOR'
    | 'IS_TYPING'
    | 'REMOVE_QUEUE'
    | 'MESSAGE'
    | 'NOTIFICATION'
    | 'CLEAR'
    | 'MODERATOR_JOIN'
    | 'MODERATOR_LEAVE'
    | 'VISITOR_JOIN'
    | 'VISITOR_LEAVE'
    | 'ONE_ON_ONE_INVITE'
    | 'TASK_PARTICIPANT_JOINED'
    | 'TASK_PARTICIPANT_LEFT'
    | 'WRAPUP_TASK';
}

export interface IObjectToArray<T> {
  key: string;
  val: T;
}
